module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_moere_og_romsdal_pos.5ba11899.png";